module.exports = __webpack_public_path__ + "static/media/InkFree.8e6141e9.woff";